// 資產卡片組件
export default {
  // 圖表標題
  assetDistribution: "資產分佈",
  totalAssetBalanceChange: "總資產餘額變化(近六個月)",
  unit: "單位：USDT",

  // 提示信息
  dataCalculating: "總資產餘額變化數據計算中，請稍後查看",
};
